import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  card_main_container: {
    margin: '0',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },

  risk_button: {
    display: 'flex',
    color: 'white',
    backgroundColor: theme.palette.accents.dark,
    '&:hover': {
      backgroundColor: theme.palette.accents.main,
    },
  },

  risk_container_filled: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  risk_header: {
    display: 'flex',
    justifyContent: 'space-around',
  },

  risk_button_container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },

  risk_content_container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30px',
    borderRadius: '5px',
    minWidth: '20%',
  },

  risk_content_empty: {
    border: '1px solid gray',
    fontStyle: 'italic',
    background: 'transparent',
    height: '30px',
    borderRadius: '5px',
    minWidth: '20%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  risk_content_container_empty: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },

  patient_risk_title: {
    marginRight: '10px',
  },

  patient_relative_risk_empty: {
    fontSize: '0.8rem',
    minWidth: '35px',
    color: '#c2c2c2',
  },

  patient_relative_risk: {
    fontSize: theme.fonts.responsiveMedium,
    letterSpacing: '0.1rem',
    fontWeight: 'bold',
  },

  patient_risk_high: {
    color: theme.palette.riskClasses.high,
  },

  patient_risk_moderate: {
    color: theme.palette.riskClasses.moderate,
  },

  patient_risk_low: {
    color: theme.palette.riskClasses.low,
  },

  risk_assessment_container_filled: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    height: '100%',
  },

  risk_assessment_container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    marginLeft: '16px',
    height: '100%',
    flexDirection: 'column',
  },

  patient_recommendations_title: {
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.texts.secondary,
    fontSize: theme.fonts.responsiveMediumBig,
    whiteSpace: 'nowrap',
    margin: '2px 8px',
  },

  recomendation_text: {
    fontSize: theme.fonts.responsiveMediumBig,
    display: 'flex',
    whiteSpace: 'normal',
    letterSpacing: '0.08em',
    alignItems: 'center',
  },

  recommendation_list: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '100%',
    background: '#494949',
    borderRadius: '5px ',
    padding: '0 8px',
    marginRight: '8px',
  },

  risk_avatar: {
    width: '20px',
    height: '20px',
  },
  risk_icon: {
    color: '#424242',
  },
  patient_risk_high_icon: {
    background: theme.palette.riskClasses.high,
  },

  patient_risk_moderate_icon: {
    background: theme.palette.riskClasses.moderate,
  },

  patient_risk_low_icon: {
    background: theme.palette.riskClasses.low,
  },

  risk_info_text: {
    color: '#ffffffb3',
    fontSize: theme.fonts.responsiveMedium,
    display: 'flex',
    whiteSpace: 'normal',
    letterSpacing: '0.08em',
  },

  risk_info_placeholder: {
    fontSize: theme.fonts.responsiveMedium,
    display: 'flex',
    whiteSpace: 'normal',
    letterSpacing: '0.08em',
    maxWidth: '95%',
  },

  summary_fabs: {
    margin: '4px',
    height: '22px',
    width: '22px',
    minHeight: '22px',
    minWidth: '22px',
    backgroundColor: theme.palette.accents.dark,

    '&:hover': {
      backgroundColor: theme.palette.accents.main,
      boxShadow: '0px 0px 5px 0px #d7c2c2',
    },
  },

  risk_btn_container: {
    width: '100%',
    display: 'flex',
    margin: '4px 0 0 0',
    padding: '0 4px',
    height: 35,
    minHeight: 35,
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.texts.generalTitleBackgrounds}`,
    justifyContent: 'flex-end',
  },

  recommendation_container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },

  tooltip_text: {
    letterSpacing: '0.1rem',
    fontSize: '12px',
  },

  actionButton: {
    color: 'white',
    minWidth: '80px',
    height: '18px',
    minHeight: '18px',
    margin: '4px',
    fontSize: theme.fonts.responsiveSmall,
    backgroundColor: theme.palette.accents.dark,
    '&:hover': {
      background: `${theme.palette.accents.main} !important`,
      boxShadow: '0px 0px 5px 0px #d7c2c2',
    },
  },

  risk_cards_container: {
    padding: '0 8px',
    width: '100%',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'flex-end',
    overflow: 'hidden',
  },

  risk_card: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: '20%',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    padding: '6px',
    marginLeft: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },

  risk_card_content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },

  risk_card_title: {
    fontSize: theme.fonts.responsiveMedium,
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },

  risk_card_value: {
    fontSize: theme.fonts.responsiveMediumBig,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
    marginLeft: '8px',
  },

  risk_card_explanation: {
    fontSize: '10px',
    color: 'gray',
    lineHeight: 2,
    letterSpacing: '0.1rem',
    marginTop: '4px',
  },

  recommendations: {
    fontWeight: theme.fonts.responsiveMedium,
  },

  tooltip_risk_container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginBottom: '10px',
  },

  draggable_risk_info: {
    marginRight: '10px',
  },

  patient_risk_title: {
    marginRight: '10px',
  },

  lifetime_risk_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#898989',
    borderRadius: '5px',
    margin: '4px',
    padding: '4px',
    justifyContent: 'center',
  },

  patient_relative_risk: {
    fontSize: theme.fonts.responsiveMedium,
    letterSpacing: '0.1rem',
    fontWeight: 'bold',
  },

  average_results_text: {
    fontStyle: 'italic',
    fontSize: theme.fonts.responsiveSmall,
    margin: '4px',
    letterSpacing: '0.1rem',
    textAlign: 'justify',
  },
}));
